<mat-form-field appearance="outline">
  <mat-select [formControl]="formControl" (selectionChange)="notify()" [disabled]="disabled">
    @for (option of optionArray; track identify($index, option)) {
    <mat-option id="option-{{ option.label }}" value="{{ option.value }}">{{ option.label }}</mat-option>
    }
  </mat-select>
</mat-form-field>
